import React from "react";

import "./_FloatingButton.scss";

const FloatingButtonContainer = (props) => {
  return (
    <nav className={`fab-container ${props.className}`} style={props.styles}>
      {props.children}
    </nav>
  );
};

const FloatingButton: React.FC<{
  onClick?: () => void;
  bntClassName?;
  id?: string;
  btnRotate?: boolean;
  children;
  btnStyles?;
}> = (props) => {
  return (
    <button
      id={props.id}
      onClick={props.onClick}
      className={`fab-item ${props.bntClassName} bg-secondary ${
        props.btnRotate ? "fab-rotate" : ""
      }`}
      //   tooltip={props.tooltip}
    >
      {props.children}
    </button>
  );
};

// const FloatingLink = (props) => {
//   return (
//     <a
//       href={props.href}
//       className={`fab-item ${props.className} ${
//         props.rotate ? "fab-rotate" : ""
//       }`}
//       tooltip={props.tooltip}
//       style={props.styles || defaultItemStyles}
//     >
//       <i className={props.icon} style={props.iconStyles}></i>
//       {props.children}
//     </a>
//   );
// };

export { FloatingButtonContainer, FloatingButton };
